module.exports = __webpack_public_path__ + "img/fi_2838764.dbde43d7.svg";